export interface Category {
  name: string;
  slug: string;
  url: string;
  isPopular: boolean;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    isPopular: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20platform%20sneakers%20on%20a%20warm%20terracotta%20clay%20surface%20with%20soft%20directional%20shadow%2C%20editorial%20fashion%20product%20shot%2C%20clean%20modern%20photography%2C%20warm%20earthy%20tones%2C%20natural%20morning%20light%20streaming%20diagonally%2C%20no%20people&width=400&height=300&seq=cat-shoes-v4-q2&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    isPopular: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20sage%20green%20hoodie%20draped%20gracefully%20over%20a%20pale%20oak%20wooden%20chair%2C%20soft%20diffused%20window%20light%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20interior%2C%20linen%20texture%20visible%2C%20calm%20and%20airy%20aesthetic&width=400&height=300&seq=cat-hoodies-v4-q2&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    isPopular: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20t-shirts%20in%20muted%20ochre%20and%20sand%20colors%20stacked%20neatly%20on%20a%20light%20marble%20surface%2C%20minimalist%20flat%20lay%20fashion%20photography%2C%20warm%20diffused%20lighting%2C%20clean%20sophisticated%20product%20presentation&width=400&height=300&seq=cat-tshirts-v4-q2&orientation=landscape',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20beige%20trench%20coat%20elegantly%20hung%20on%20a%20minimalist%20wall%20hook%20against%20a%20warm%20plaster%20wall%2C%20soft%20natural%20light%20from%20side%20window%2C%20editorial%20fashion%20photography%2C%20sophisticated%20neutral%20palette%2C%20gentle%20shadows&width=400&height=300&seq=cat-jackets-v4-q2&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20and%20relaxed%20cotton%20shorts%20artfully%20arranged%20on%20a%20rattan%20surface%20with%20tropical%20leaf%20shadow%20pattern%2C%20warm%20golden%20hour%20light%2C%20resort%20fashion%20editorial%20photography%2C%20breezy%20sophisticated%20aesthetic&width=400&height=300&seq=cat-pants-v4-q2&orientation=landscape',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20wide%20brim%20straw%20hat%20and%20soft%20cashmere%20beanie%20displayed%20on%20a%20warm%20sandy%20textured%20surface%2C%20gentle%20afternoon%20sunlight%2C%20bohemian%20fashion%20editorial%20photography%2C%20earthy%20neutral%20tones%2C%20relaxed%20luxury%20aesthetic&width=400&height=300&seq=cat-headwear-v4-q2&orientation=landscape',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20linen%20co-ord%20set%20in%20warm%20terracotta%20hue%20laid%20out%20on%20a%20textured%20cream%20fabric%20background%2C%20soft%20diffused%20natural%20light%2C%20editorial%20fashion%20flat%20lay%2C%20minimalist%20bohemian%20aesthetic%2C%20gentle%20organic%20folds&width=400&height=300&seq=cat-sets-v4-q2&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20underwear%20basics%20folded%20neatly%20on%20a%20pale%20linen%20fabric%20surface%2C%20gentle%20diffused%20morning%20light%2C%20clean%20minimalist%20product%20photography%2C%20warm%20ivory%20and%20blush%20tones%2C%20serene%20wellness%20aesthetic&width=400&height=300&seq=cat-underwear-v4-q2&orientation=landscape',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20style%20football%20jersey%20in%20deep%20forest%20green%20draped%20on%20a%20wooden%20hanger%20against%20a%20textured%20off%20white%20wall%2C%20warm%20afternoon%20light%20casting%20long%20shadows%2C%20sports%20heritage%20editorial%20photography%2C%20nostalgic%20athletic%20aesthetic&width=400&height=300&seq=cat-jersey-v4-q2&orientation=landscape',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20collection%20of%20minimalist%20gold%20toned%20jewelry%20and%20sunglasses%20scattered%20on%20a%20travertine%20stone%20surface%2C%20warm%20golden%20hour%20light%2C%20luxury%20accessories%20editorial%20photography%2C%20sophisticated%20neutral%20palette%2C%20refined%20composition&width=400&height=300&seq=cat-accessories-v4-q2&orientation=landscape',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20leather%20tote%20bag%20in%20warm%20cognac%20brown%20placed%20on%20a%20minimalist%20concrete%20bench%2C%20soft%20natural%20light%2C%20luxury%20accessories%20editorial%20photography%2C%20sophisticated%20contemporary%20aesthetic%2C%20clean%20architectural%20background&width=400&height=300&seq=cat-bags-v4-q2&orientation=landscape',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20in%20rich%20chocolate%20and%20caramel%20tones%20coiled%20elegantly%20on%20a%20warm%20terracotta%20tiled%20surface%2C%20soft%20afternoon%20light%2C%20artisanal%20accessories%20photography%2C%20warm%20earthy%20palette%2C%20refined%20handmade%20aesthetic&width=400&height=300&seq=cat-belts-v4-q2&orientation=landscape',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Artisanal%20glass%20perfume%20bottles%20with%20amber%20and%20rose%20colored%20fragrances%20arranged%20on%20a%20warm%20wooden%20surface%2C%20soft%20diffused%20light%20through%20sheer%20curtains%2C%20luxury%20fragrance%20editorial%20photography%2C%20sophisticated%20apothecary%20aesthetic&width=400&height=300&seq=cat-perfumes-v4-q2&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    isPopular: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20lifestyle%20products%20including%20notebook%20candle%20and%20ceramic%20mug%20on%20a%20warm%20oak%20tabletop%2C%20soft%20morning%20light%2C%20cozy%20home%20editorial%20photography%2C%20warm%20neutral%20aesthetic%2C%20mindful%20living%20concept&width=400&height=300&seq=cat-otherstuff-v4-q2&orientation=landscape',
  },
];